import { report_graph_sensorService } from '../_services';

const state = { onRequest: false, report_graph_sensor: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_graph_sensorService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_graph_sensor: state => {
    return state.report_graph_sensor
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_graph_sensor = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_graph_sensor = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_graph_sensor = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_graph_sensors = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
